/*
SaiKrishna 10/06/2022 2701127043 Removed unnecessary console.log statements
Suresh Peddavoora  10/26/2022 2701127043 Added classname for formula rule group table .
Suresh Peddavoora  10/28/2022 2701127043 Added outlined icons and  Class Name for Table .
Ashraf 10/30/2022 2701127043 fixed table pagination issue
saikrishna 11/03/2022 2701127043 changed the paginationOptions
Dilip 11/03/2022 2701127043 added rule code to delete popup
Ashraf 11/18/2022 2701127043 commented test rule code at row level
Raghu 12/9/2022  2701127043 Table footer styling fixes
kavyareddy 12/15/2022 2701127043 Added role disable condition
Ashraf 12/15/2022 2701127043 fixed role disable condition
Ashraf 15/16/2022 2701127043 fixed role access
akhila 12/23/2022 2701127043 removed createdBy
Akhila 01/20/2023 2701127043 unsaved chnages stepper issue fixed
Ravi 02/08/2023 2701127043 fixed spacing issue
Raghu 02/28/2023 2701127043 added new class for table
Prakash 12/04/2023 2701127043 fixed alignments issue in table.
Ravi 05/31/2023 2701127043 changed delete popup message
*/
import React, {useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../../components/PageLoader';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {useSelector} from 'react-redux';
export default function RuleGroupTable({
  formData,
  setFormData,
  deletedRules,
  setDeletedRules,
  setIsEditMode,
  disableEdit,
  disableDelete,
  setOpen,
  breCode,
  roleDataAccessDc,
  rowData,
  setRowData,
  setOldRuleCode,
  editExisting,
  dirtyRef,
}) {
  const [rows, setRows] = useState(defaultRows);

  const columns = [
    {
      title: 'Rule Code',
      field: 'ruleCode',
      // cellStyle: { maxWidth: 500 },
      // minWidth: "300px",
    },
    {
      title: 'Expression',
      field: 'expression',
      // width: "2%",
      // headerStyle: { textAlign: "left", fontSize: 16 },
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >

            {rowData.expression}

          </div>
        </>
      ),
    },
  ];
  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);

  const {basicInfoData} = useSelector(({addRuleGroup}) => addRuleGroup);
  const handleEditRow = (rowData) => {
    setIsEditMode(true);
    setRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    setLoader(true);
    new Promise((resolve) => {
      setTimeout(() => {
        const data = [...formData];
        const newData = data.filter((row) => row.ruleCode !== userData.ruleCode);
        setFormData(newData);
        userData?.ruleId && deletedRules.length > 0 ?
          setDeletedRules([...deletedRules, userData.ruleId]) :
          setDeletedRules([userData.ruleId]);
        resolve();
        handleCloseDialog();
        setLoader(false);
      }, 1000);
      dirtyRef.current = true;
    });
  };

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Rule"
        value={`Are you sure you want to delete the ${userData?.ruleCode} Rule?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="new-standard-textfields">
        <div className="custom-table global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={formData}
            textAlign="left"
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                // disabled: breCode && !disableEdit,
                disabled: basicInfoData?.addRule?.length > 0 && !roleDataAccessDc?.edit && editExisting,
                onClick: (event, rowData) => {
                  handleEditRow(rowData);
                  setOldRuleCode(rowData.ruleCode);
                },
              },
              // (rowData) => ({
              //   icon: () => <PlayCircleFilledWhiteOutlinedIcon />,
              //   disabled: breCode && !disableEdit,
              //   tooltip: "Test Rule Code ",
              // }),
              {
                icon: () => <DeleteOutlineOutlinedIcon />,
                // disabled: breCode && !disableDelete,
                disabled: basicInfoData?.addRule?.length > 0 && !roleDataAccessDc?.edit && editExisting,
                tooltip: 'Delete',
                onClick: (event, rowData) => handleDelete(rowData),
              },
            ]}
          />
        </div>
      </Grid>
      {loader && <PageLoader />}
    </>
  );
}
